import { useState, useEffect } from "react";
import useClickOutside from "../../../CustomHooks/useClickOutside";
import { Search } from "lucide-react";
import { Controller } from "react-hook-form";

const MultiCheckDropdown = ({
  name,
  label,
  options,
  keyName,
  keyId,
  showOptionId,
  error,
  selectedOptions,
  control,
  disableValidationMessage,
}) => {
  const [searchList, setSearchList] = useState(options);
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));

  const isRole = selectedOptions?.length > 0;

  const handleShowDropdown = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filter = options.filter((item) => {
      const matchesName = item[keyName]
        ?.toString()
        .toLowerCase()
        .includes(value);

      const matchesId =
        showOptionId && item[keyId]?.toString().toLowerCase().includes(value);

      return matchesName || matchesId;
    });

    setSearchList(filter);
  };

  useEffect(() => {
    setSearchList(options);
  }, [options]);

  return (
    <>
      <label htmlFor={name} className="checkBoxDropdownLabel">
        {label}
      </label>
      <div className="relative" ref={dropdownRef}>
        <p
          onClick={() => handleShowDropdown()}
          className={`checkBoxDropdownLabelWrap ${
            error ? "border-red-500" : "border-lg4"
          }`}
        >
          {isRole ? `${"Selected"} (${selectedOptions.length})` : "Select"}
          <span
            className={`checksDropdownArr ${
              open === 1 ? "rotate-90" : "rotate-90n"
            }`}
          >{`<`}</span>
        </p>
        <div
          className={`checksOptionWrap ${
            open === 1 ? "grid opacity-1" : "invisible opacity-0"
          }`}
        >
          <p className="mb-2">
            <input
              type="text"
              placeholder="Search"
              onChange={handleSearch}
              className="cy-search-inp"
            />
            <Search size={16} className="absolute right-4 top-4" />
          </p>
          <Controller
            name={name}
            control={control}
            rules={{
              validate: (value) =>
                disableValidationMessage ||
                value.length !== 0 ||
                "Please select at least one option.",
            }}
            render={({ field }) => {
              const { value = [], onChange } = field;
              const handleCheckbox = (id) => {
                if (value.includes(id)) {
                  onChange(value.filter((r) => r !== id));
                } else {
                  onChange([...value, id]);
                }
              };

              return (
                <>
                  {searchList.length > 0 ? (
                    <ul className="h-40 overflow-y-scroll">
                      {searchList.map((item) => (
                        <li key={item[keyId]} className="checksItems">
                          <input
                            type="checkbox"
                            id={item[keyId]}
                            checked={value.includes(item[keyId])}
                            onChange={() => handleCheckbox(item[keyId])}
                            className="accent-input"
                          />
                          <label htmlFor={item[keyId]} className="checksLabel">
                            {item[keyName]} ({showOptionId && item[keyId]})
                          </label>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="py-1 px-2 text-sm text-red-400">Not Found</p>
                  )}
                </>
              );
            }}
          />
        </div>
        <p className={`input-err ${error ? "visible" : "invisible"}`}>
          {error?.message}
        </p>
      </div>
    </>
  );
};
export default MultiCheckDropdown;
